export const getHomepageBannerService = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/botbdynamiccontent/GetHomepageBanner`);
